import React, { useState } from 'react'
import { connect } from 'react-redux'
import { object, string, array, bool } from 'prop-types'
import { Button } from '@livechat/design-system-react-components'

import { pushEvent } from '@/utils/analytics'
import { activeProduct, navigateToIFrame } from '@/utils'
import {
  getCartId,
  getCartProducts,
  isSubscriptionAssigned,
} from '@/store/selectors'
import ActivateSubscriptionModal from './ActivateSubscriptionModal'

const GoToSubscriptionButton = ({
  cartId,
  cartProductsIds,
  buttonProps,
  trackEvent,
  path,
  directlyToSubscription,
  isNotAssignedToProduct,
  product = activeProduct,
  label = 'Continue to subscription',
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const toggleModal = () => setIsModalOpen((prev) => !prev)

  const goToSubscriptionPage = (e) => {
    if (trackEvent) {
      pushEvent({
        event: trackEvent,
        payload: {
          cartId,
          appIds: cartProductsIds || [],
        },
      })
    }

    navigateToIFrame(e, path, product)
  }

  if (isNotAssignedToProduct && !directlyToSubscription) {
    return (
      <>
        <Button onClick={toggleModal} {...buttonProps}>
          {label}
        </Button>

        {isModalOpen && (
          <ActivateSubscriptionModal
            onCloseModal={toggleModal}
            onClick={goToSubscriptionPage}
            product={product}
          />
        )}
      </>
    )
  }

  return (
    <Button onClick={goToSubscriptionPage} {...buttonProps}>
      {label}
    </Button>
  )
}

GoToSubscriptionButton.propTypes = {
  cartId: string,
  buttonProps: object,
  cartProductsIds: array,
  label: string,
  trackEvent: string,
  path: string,
  product: string,
  isNotAssignedToProduct: bool,
  directlyToSubscription: bool,
}

const mapStateToProps = (state, ownProps) => {
  const cartId = getCartId(state)
  const cartProductsIds = getCartProducts(state)?.map(({ id }) => id)
  const isNotAssignedToProduct = !isSubscriptionAssigned(
    state,
    ownProps?.product
  )

  return {
    cartId,
    cartProductsIds,
    isNotAssignedToProduct,
  }
}

export default connect(mapStateToProps)(GoToSubscriptionButton)
